import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Button, Card } from "react-bootstrap";
import { getUserSession } from "../component/userInfo";
import ReactQuill, { Quill } from "react-quill"; // Import ReactQuill
import "react-quill/dist/quill.snow.css"; // Import Quill's CSS
import "../component/react-quill-custom.css"; // Custom CSS for ReactQuill

const AdminBoardForm = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const isEditMode = Boolean(postId);

  useEffect(() => {
    if (isEditMode) {
      fetchPostData();
    }
  }, [postId]);

  const fetchPostData = async () => {
    const formData = new FormData();
    formData.append("action", "view");
    formData.append("post_id", postId);

    try {
      const res = await fetch(
        "https://work.wekoinonia.org/json/admin_board.php",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success) {
        setTitle(data.post.title);
        setContent(data.post.content);
      } else {
        // alert(data.message);
        const mockData = {
          success: true,
          post: {
            title: "테스트 게시글 제목",
            content: "테스트 게시글 내용입니다.",
          },
        };
        setTitle(mockData.post.title);
        setContent(mockData.post.content);
      }
    } catch (error) {
      console.error("Failed to fetch post data:", error);
      // alert('게시글 정보를 불러오는 데 실패했습니다.');
      const mockData = {
        success: true,
        post: {
          title: "테스트 게시글 제목",
          content: "테스트 게시글 내용입니다.",
        },
      };
      setTitle(mockData.post.title);
      setContent(mockData.post.content);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !content || content === "<p><br></p>") {
      // Check for empty content from editor
      alert("제목과 내용을 모두 입력해주세요.");
      return;
    }

    const userSession = getUserSession();
    const formData = new FormData();
    formData.append("uid", userSession.uid);
    formData.append("action", isEditMode ? "update" : "create");
    formData.append("title", title);
    formData.append("content", content); // Content from ReactQuill
    if (isEditMode) {
      formData.append("post_id", postId);
    }

    try {
      const res = await fetch(
        "https://work.wekoinonia.org/json/admin_board.php",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success) {
        alert(
          isEditMode ? "게시글이 수정되었습니다." : "게시글이 작성되었습니다."
        );
        navigate("/adminboard");
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Failed to save post:", error);
      alert("게시글 저장에 실패했습니다.");
    }
  };

  // 1. Font format 가져오기
  const Font = Quill.import("formats/font");

  console.log("Font formats before:", Font.whitelist);
  // 2. 허용할 폰트 목록 지정 (CSS class 이름 기준)
  Font.whitelist = [
    ...(Font.whitelist || []), // ✅ 기존 whitelist 유지하면서 추가
    "sans-serif",
    "gothic",
    "noto-sans-kr",
    "nanum-gothic",
    "nanum-myeongjo",
    "malgun-gothic",
  ];
  // 중복 제거 (권장)
  Font.whitelist = Array.from(new Set(Font.whitelist));

  // 3. 다시 등록
  Quill.register(Font, true);

  const modules = {
    toolbar: [
      [
        { header: "1" },
        { header: "2" },
        {
          font: Font.whitelist,
        },
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "list",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "color",
    "background",
    "align",
    "link",
    "image",
  ];

  return (
    <div>
      <h1 className="h3 mb-2 text-gray-800">
        {isEditMode ? "게시글 수정" : "새 글 작성"}
      </h1>
      <Card className="shadow mb-4">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formTitle">
              <Form.Label>제목</Form.Label>
              <Form.Control
                type="text"
                placeholder="제목을 입력하세요"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formContent">
              <Form.Label>내용</Form.Label>
              <ReactQuill
                className="admin-quill-editor"
                theme="snow"
                value={content}
                onChange={setContent}
                modules={modules}
                formats={formats}
                placeholder="내용을 입력하세요"
              />
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                onClick={() => navigate("/adminboard")}
                className="me-2"
              >
                취소
              </Button>
              <Button variant="primary" type="submit">
                {isEditMode ? "수정하기" : "작성하기"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AdminBoardForm;
